// src/components/practices/shared/PracticeComplete.js
// Calm, small completion acknowledgement for a finished Practice — explicitly NOT
// CompletionJourney (no acts, no postcard carousel, no confetti canvas, no html2canvas
// share-card pipeline). Every Practice's completion should feel like this, per spec: "✦ Practice
// Complete", one line of context, "Done." headline/subline are supplied per-Practice so wording
// can vary ("4 intentions turned into gratitude", "You found another way to see it.", etc.).
import React from 'react'
import PrimaryButton from '../../ui/PrimaryButton'
import './PracticeComplete.css'

export default function PracticeComplete({ headline = 'Practice Complete', subline, onDone, showSaveToMoments }) {
  return (
    <div className="practice-complete-screen" data-city="august">
      <div className="practice-complete">
        <div className="practice-complete-mark">✦</div>
        <h2 className="practice-complete-headline">{headline}</h2>
        {subline && <p className="practice-complete-subline">{subline}</p>}

        <PrimaryButton onClick={onDone}>
          <span>Done</span>
          <span>✦</span>
        </PrimaryButton>

        {/* Real Moments integration needs its own design pass — saveMoment expects an imageUrl,
            which a text-only Practice completion doesn't have. Honest stub, not a silent no-op. */}
        {showSaveToMoments && (
          <button type="button" className="practice-complete-save-stub" disabled>
            Save to Moments — coming soon
          </button>
        )}
      </div>
    </div>
  )
}
